import I18n from 'I18n';
import { useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { enterpriseDefaultSurveyResponseMap, nextStepsSurveyOptions } from '../../../constants/trial';
import { mapRedirectTargetToRouteFromApiName, navigateTo } from '../../../utils/trials';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const shuffledOptions = Object.values(nextStepsSurveyOptions).sort(() => Math.random() - 0.5);
export const EnterpriseNextStepsSurvey = ({
  apiName,
  trackingData,
  trialTrackingProperties,
  upgradeConfig
}) => {
  const [showRedirectSurvey, setShowRedirectSurvey] = useState(false);
  const randomizedSurveyOptions = useMemo(() => {
    var _enterpriseDefaultSur;
    return [...((_enterpriseDefaultSur = enterpriseDefaultSurveyResponseMap[apiName]) !== null && _enterpriseDefaultSur !== void 0 ? _enterpriseDefaultSur : [])].sort(() => Math.random() - 0.5);
  }, [apiName]);
  const trackInteraction = option => {
    const trackerProperties = Object.assign({}, getTrackingProperties({
      apiName,
      trackingData,
      upgradeConfig
    }), trialTrackingProperties);
    switch (option) {
      case nextStepsSurveyOptions.CREATE_NEW_USERS:
        track('trialActivationInteraction', Object.assign({
          action: 'clicked create new users'
        }, trackerProperties));
        break;
      case nextStepsSurveyOptions.SPECIFIC_FEATURE:
        track('trialActivationInteraction', Object.assign({
          action: 'clicked try out a specific feature'
        }, trackerProperties));
        break;
      case nextStepsSurveyOptions.EXPLORE_ON_YOUR_OWN:
        track('trialActivationInteraction', Object.assign({
          action: 'clicked explore on my own'
        }, trackerProperties));
        break;
      default:
        break;
    }
  };
  const handleOptionClick = option => {
    trackInteraction(option);
    switch (option) {
      case nextStepsSurveyOptions.CREATE_NEW_USERS:
        navigateTo(mapRedirectTargetToRouteFromApiName('user-settings'));
        break;
      case nextStepsSurveyOptions.SPECIFIC_FEATURE:
        setShowRedirectSurvey(true);
        break;
      case nextStepsSurveyOptions.EXPLORE_ON_YOUR_OWN:
        navigateTo(mapRedirectTargetToRouteFromApiName('other', apiName));
        break;
      default:
        break;
    }
  };
  const handleRedirect = value => {
    navigateTo(mapRedirectTargetToRouteFromApiName(value, apiName));
  };
  if (showRedirectSurvey) {
    return /*#__PURE__*/_jsxs(Modal, {
      centered: true,
      use: "success",
      width: 600,
      children: [/*#__PURE__*/_jsx(DialogHeaderImage, {
        offsetTop: 40,
        offsetBottom: -30,
        children: /*#__PURE__*/_jsx(Illustration, {
          name: "success",
          width: 118
        })
      }), /*#__PURE__*/_jsx(DialogHeader, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.trial.nextStepsSurvey.redirectModal.header"
          })
        })
      }), /*#__PURE__*/_jsx(DialogFooter, {
        children: /*#__PURE__*/_jsxs(View, {
          marginBlockStart: "600",
          inlineSize: "100%",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "purchaseMotions.trial.nextStepsSurvey.featureExplore"
            })
          }), /*#__PURE__*/_jsxs(List, {
            children: [randomizedSurveyOptions.map(option => /*#__PURE__*/_jsx(ListItem, {
              marginBlockEnd: "200",
              children: /*#__PURE__*/_jsx(SelectableBox, {
                type: "default",
                block: true,
                name: option,
                onClick: () => handleRedirect(option),
                children: /*#__PURE__*/_jsx(Flex, {
                  flexDirection: "row",
                  alignItems: "center",
                  children: /*#__PURE__*/_jsx(Text, {
                    textAlign: "start",
                    as: "strong",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: `purchaseMotions.trial.nextStepsSurvey.survey.${option}.description`
                    })
                  })
                })
              }, option)
            }, option)), /*#__PURE__*/_jsx(ListItem, {
              marginBlockEnd: "200",
              children: /*#__PURE__*/_jsx(SelectableBox, {
                type: "default",
                block: true,
                name: "other",
                onClick: () => handleRedirect('other'),
                children: /*#__PURE__*/_jsx(Flex, {
                  flexDirection: "row",
                  alignItems: "center",
                  children: /*#__PURE__*/_jsx(Text, {
                    textAlign: "start",
                    as: "strong",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "purchaseMotions.trial.nextStepsSurvey.survey.ownExplore"
                    })
                  })
                })
              })
            })]
          })]
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Modal, {
    centered: true,
    use: "success",
    width: 600,
    children: [/*#__PURE__*/_jsx(DialogHeaderImage, {
      offsetTop: 40,
      offsetBottom: -30,
      children: /*#__PURE__*/_jsx(Illustration, {
        name: "success",
        width: 118
      })
    }), /*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.trial.nextStepsSurvey.thanksForActivatingTrial"
        })
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsxs(View, {
        as: "div",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.trial.nextStepsSurvey.subHeader",
          options: {
            productName: I18n.text(`purchaseMotions.products.${apiName}`)
          }
        }), /*#__PURE__*/_jsxs(View, {
          marginBlockStart: "600",
          inlineSize: "100%",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "purchaseMotions.trial.nextStepsSurvey.firstAction"
            })
          }), /*#__PURE__*/_jsx(List, {
            children: shuffledOptions.map(option => /*#__PURE__*/_jsx(ListItem, {
              marginBlockEnd: "200",
              children: /*#__PURE__*/_jsx(SelectableBox, {
                type: "default",
                block: true,
                name: option,
                onClick: () => handleOptionClick(option),
                children: /*#__PURE__*/_jsx(Flex, {
                  flexDirection: "row",
                  alignItems: "center",
                  children: /*#__PURE__*/_jsx(Text, {
                    textAlign: "start",
                    as: "strong",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: `purchaseMotions.trial.nextStepsSurvey.actions.${option}`
                    })
                  })
                })
              })
            }, option))
          })]
        })]
      })
    })]
  });
};